export function compactNumberFormat(
  num: number,
  formatTreshold: number | null = null,
): string {
  if (formatTreshold === null || num >= formatTreshold) {
    if (num >= 999950) {
      return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
    }
  }

  return num.toString();
}
